import { FC } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import loadable from "@loadable/component";

import HomePage from "./pages/HomePage";
const ProfilePage = loadable(() => import("./pages/ProfilePage"));

const ManageReservationPage = loadable(
  () => import("./pages/ManageReservationPage")
);
const YourReservationPage = loadable(
  () => import("./pages/YourReservationPage")
);
const ErrorPage = loadable(() => import("./pages/ErrorPage"));
const FAQ = loadable(() => import("./pages/StaticPages/FAQ"));
const Privacy = loadable(() => import("./pages/StaticPages/Privacy"));
const Reward = loadable(() => import("./pages/StaticPages/Reward"));
const RomingoRewards = loadable(
  () => import("./pages/StaticPages/RomingoRewards")
);
const CreateAccount = loadable(() => import("./pages/CreateAccount"));
const SignIn = loadable(() => import("./pages/SignIn"));
const ResetPassword = loadable(() => import("./pages/ResetPassword"));

const Blog = loadable(() => import("./pages/Blog"));
const BlogPost = loadable(() => import("./pages/BlogPost"));
const NotFound = loadable(() => import("./pages/NotFound"));

import { authService } from "./services/authService.js";

const ListingPageNew = loadable(() => import("./pages/ListingPage/ListingPageNew"));
import CancellationPage from "./pages/CancellationPage";
// import StripeWrapper from "./components/stripe/StripeWrapper";

interface RouteInterface {
  path: string;
  component: FC<any>;
  requireAuth: boolean;
}

const routes: RouteInterface[] = [
  {
    path: "/",
    component: HomePage,
    requireAuth: false,
  },
  {
    path: "/listings",
    component: ListingPageNew,
    requireAuth: false,
  },
  {
    path: "/profile",
    component: ProfilePage,
    requireAuth: false,
  },
  {
    path: "/reservation/manage",
    component: ManageReservationPage,
    requireAuth: false,
  },
  {
    path: "/faq",
    component: FAQ,
    requireAuth: false,
  },
  {
    path: "/privacy",
    component: Privacy,
    requireAuth: false,
  },
  {
    path: "/romingo-rewards/terms-conditions",
    component: Reward,
    requireAuth: false,
  },
  {
    path: "/romingo-rewards",
    component: RomingoRewards,
    requireAuth: false,
  },
  {
    path: "/blog/",
    component: Blog,
    requireAuth: false,
  },
  {
    path: "/blog/post/:id",
    component: BlogPost,
    requireAuth: false,
  },
  {
    path: "/create-account",
    component: CreateAccount,
    requireAuth: false,
  },
  {
    path: "/login",
    component: SignIn,
    requireAuth: false,
  },
  {
    path: "/reset-password",
    component: ResetPassword,
    requireAuth: false,
  },
];

const AuthGuards = (props: any) => {
  const token = authService.getToken();
  if (token && props.children) {
    return props.children;
  }

  return <Navigate to="/login" replace />;
};

const AllRoutes = () => {
  return (
    <Routes>
      {routes.map(
        (route, key) => {
          if (!route.requireAuth)
            return (
              <Route
                path={route.path}
                element={<route.component />}
                key={key}
              />
            );
          else
            return (
              <AuthGuards key={key}>
                <Route path={route.path} element={<route.component />} />
              </AuthGuards>
            );
        }
        // <Route
        //   path={route.path}
        //   element={<route.component />}
        //   key={key}
        // />
      )}

      <Route
        path="/reservation/details"
        element={
  
          <YourReservationPage />
          
        }
      />
      <Route path="/reservation/cancelled" element={<CancellationPage />} />

      {/* Catch-all route for 404 */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AllRoutes;
